export enum NotificationSourceModule {
    SECURE_DOCUMENT_STORE = 'SECURE-DOCUMENT-STORE',
    SECURE_INBOX = 'SECURE-INBOX',
    APPOINTMENTS = 'APPOINTMENTS',
}
